import React from 'react';
import {NavLink} from 'react-router-dom';

const NavigationButton = (props) => {
    return(
        <div className="nav-btn-container">
            <NavLink className="nav-link" to={props.route}>
                <div className="nav-btn">
                    <i className={props.iconName}></i>
                    <p>{props.title}</p>
                </div>
            </NavLink>
            {/* <a href={props.route}><i className={props.iconName}></i></a> */}
        </div>
    )
}

export default NavigationButton;